module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjNGI3N2JlIj48cGF0aCBkPSJNNDAtMTIwdi0yMDBoODB2MTIwaDEyMHY4MEg0MFptNjgwIDB2LTgwaDEyMHYtMTIwaDgwdjIwMEg3MjBaTTE2MC0yNDB2LTQ4MGg4MHY0ODBoLTgwWm0xMjAgMHYtNDgwaDQwdjQ4MGgtNDBabTEyMCAwdi00ODBoODB2NDgwaC04MFptMTIwIDB2LTQ4MGgxMjB2NDgwSDUyMFptMTYwIDB2LTQ4MGg0MHY0ODBoLTQwWm04MCAwdi00ODBoNDB2NDgwaC00MFpNNDAtNjQwdi0yMDBoMjAwdjgwSDEyMHYxMjBINDBabTgwMCAwdi0xMjBINzIwdi04MGgyMDB2MjAwaC04MFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_barcode_scanner.svg
// module id = uqe1
// module chunks = 4